var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6226_12619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#E4E6EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4102 34.64C16.0202 34.92 14.6802 34.01 14.4002 32.63L11.5302 18.21C11.2502 16.83 12.1502 15.48 13.5402 15.2L19.0202 14.11L19.1502 13.46C19.1502 13.46 19.1502 13.44 19.1502 13.43L13.4102 14.57C11.6802 14.91 10.5602 16.6 10.9002 18.33L13.7702 32.75C14.0702 34.27 15.4102 35.32 16.9002 35.32C17.1102 35.32 17.3202 35.3 17.5202 35.26L20.2702 34.71L18.6102 34.39L17.4002 34.63L17.4102 34.64Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8302 14.87L23.7402 12.73C22.1802 12.43 20.6702 13.45 20.3702 15.01L17.5802 29.44C17.2802 31 18.3002 32.51 19.8602 32.81L30.9502 34.95C32.5102 35.25 34.0202 34.23 34.3202 32.67L37.1102 18.24C37.4102 16.68 36.3902 15.17 34.8302 14.87ZM31.7702 25.4L27.8902 24.65L27.1402 28.53C27.0702 28.9 26.7102 29.15 26.3302 29.07C25.9502 28.99 25.7102 28.64 25.7902 28.27L26.5402 24.39L22.6602 23.64C22.2902 23.57 22.0402 23.21 22.1202 22.84C22.2002 22.47 22.5502 22.22 22.9202 22.3L26.8002 23.05L27.5502 19.17C27.6202 18.8 27.9802 18.55 28.3502 18.63C28.7202 18.71 28.9702 19.06 28.8902 19.43L28.1402 23.31L32.0202 24.06C32.3902 24.13 32.6402 24.49 32.5602 24.86C32.4802 25.23 32.1302 25.48 31.7602 25.4H31.7702Z",
    fill: "#1C1B1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6226_12619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileIcon);
export default __webpack_public_path__ + "static/media/uploadFileIcon.6beebe9117b3c0ed7614d7006890ec5d.svg";
export { ForwardRef as ReactComponent };